module.exports = __webpack_public_path__ + "img/dog-purchase-paid.9ec9caae.png";